import { InjectionToken } from '@angular/core';

import { NavBarItemBase } from '../config/navbar-item.model';

export const MW_MENU_ITEMS = new InjectionToken<NavBarItemBase>(
  'MW_MENU_ITEMS'
);

export const MW_LAYOUT_HIDE_NAVBAR = new InjectionToken<boolean>(
  'MW_LAYOUT_HIDE_NAVBAR'
);

export const MW_SHARED_DATA = new InjectionToken<any>('MW_SHARED_DATA');
